
export default function Hero() {
  return (
    <section className="relative pt-32 pb-16 sm:pt-40 sm:pb-20 bg-[#0B1120] overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#0066CC]/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-20 w-96 h-96 bg-[#0066CC]/20 rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0066CC]/10 border border-[#0066CC]/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-[#0066CC] animate-pulse"></span>
          <span className="text-[#0066CC] text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
            Get In Touch
          </span>
        </div>
        <h1 className="text-3xl sm:text-5xl font-bold text-white mb-4 leading-tight">
          Let&apos;s Start a <span className="text-[#0066CC]">Conversation</span>
        </h1>
        <p className="text-gray-400 text-sm sm:text-base leading-relaxed max-w-xl mx-auto">
          Have a question about our defense technology solutions? We&apos;re here to help.
          Reach out and our team will respond within 24 hours.
        </p>
      </div>
    </section>
  );
}
